import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { NodeDataWithLabel } from "../types";
import { nodeAtomFamily } from "./nodeAtomFamily";

export const nodeLabelAtomFamily = atomFamily((nodeId: string) => {
  const baseAtom = atom((get) => {
    const node = get(nodeAtomFamily(nodeId));
    return (node?.data as NodeDataWithLabel)?.label ?? "";
  });

  baseAtom.debugLabel = `nodeLabelAtomFamily(${nodeId})`;
  return baseAtom;
});
